module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento2.3f0cdc92.svg";